<template>
  <div class="room-info">
    <div class="room-info__item" v-if="room.size">
      <p class="room-info__content">
        <vb-icon class="room-info__icon" :name="'zoom'" :color="sass('primary')" :size="13" />
        <span class="room-info__name">
          Superficie: {{ room.size }}m<sup>2</sup>
        </span>
      </p>
    </div>
    <div class="room-info__item" v-if="room.number_of_rooms.bathrooms">
      <p class="room-info__content">
        <vb-icon class="room-info__icon" :name="'shower'" :color="sass('primary')" :size="13" />
        <span class="room-info__name">
          Bagni in camera: {{ room.number_of_rooms.bathrooms }}
        </span>
      </p>
    </div>
    <div class="room-info__item" v-if="room.number_of_rooms.bedrooms">
      <p class="room-info__content">
        <vb-icon class="room-info__icon" :name="'bed'" :color="sass('primary')" :size="13" />
        <span class="room-info__name">
          Camere da letto: {{ room.number_of_rooms.bedrooms }}
        </span>
      </p>
    </div>
    <div class="room-info__item" v-if="room.number_of_rooms.living_rooms">
      <p class="room-info__content">
        <vb-icon class="room-info__icon" :name="'armchair'" :color="sass('primary')" :size="13" />
        <span class="room-info__name">
          Soggiorno: {{ room.number_of_rooms.living_rooms }}
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'room-info',

  components: {
  },

  props: {
    room: Object
  },

  data() {
    return {
    }
  },

  computed: {
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .room-info {
    $this: &;
    align-items: center;
    display: none;

    @include media-breakpoint-up(md){
      display: flex;
    }

    &__item {
      margin-left: $grid-gutter-width/2;

      &:first-child {
        margin-left: 0;
      }
    }

    &__content {
      display: flex;
      align-items: center;
      margin-bottom: 0;
    }

    &__name {
      margin-left: 5px;
      font-size: $font-size-sm;
    }
  }

</style>